import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { MdOutlineEventNote } from 'react-icons/md';
import './AuthorHome.css';

const AuthorHome = () => {
  const [date, setDate] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/get-date`
        );
        setDate(response.data);
      } catch (error) {
        console.error('Error fetching date data', error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <div className="loading-state">Loading important dates...</div>;
  }

  if (error) {
    return <div className="error-state">Error loading dates: {error}</div>;
  }

  return (
    <div className="author-home-container">
      <div className="dates-header">
        <h1 className="dates-title">Important Dates</h1>
        <p className="dates-subtitle">Key deadlines for the conference</p>
      </div>

      <div className="dates-container">
        <div className="date-card">
          <MdOutlineEventNote className="date-icon" />
          <div className="date-content">
            <h3>Paper Submission Deadline</h3>
            <p className="deadline-date">{date.data[0].PaperSubmissionDeadline}</p>
          </div>
        </div>

        <div className="date-card">
          <MdOutlineEventNote className="date-icon" />
          <div className="date-content">
            <h3>Acceptance Notification</h3>
            <p className="notification-date">{date.data[0].AcceptanceNotification}</p>
          </div>
        </div>

        <div className="date-card">
          <MdOutlineEventNote className="date-icon" />
          <div className="date-content">
            <h3>Registration Deadline</h3>
            <p className="registration-date">{date.data[0].RegistrationDeadline}</p>
          </div>
        </div>

        <div className="date-card">
          <MdOutlineEventNote className="date-icon" />
          <div className="date-content">
            <h3>Conference Date</h3>
            <p className="symposium-date">{date.data[0].CameraReadySubmission}</p>
          </div>
        </div>
      </div>

      <button 
        className="call-for-paper-btn"
        onClick={() => window.open('https://drive.google.com/file/d/1tgdOzNNgK87WB7Ws7ZRv2lRs_JjPhWtJ/view', '_blank')}
      >
        Call For Paper
      </button>
    </div>
  );
};

export default AuthorHome;